import { Button, Drawer, Form, Input, InputNumber, Select, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const AddGovtContribution = ({ open, close, setLoading, rerun }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleCreateGovtContrib = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-govt-contribution", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Created govt contribution successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
        if (data === "already-added") {
          rerunNotif("error", "Description already exist.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Govt Contribution"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-govt-contribution"
        initialValues={{ remember: true }}
        onFinish={handleCreateGovtContrib}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select placeholder="Select description" size="large">
              <Select.Option value={"sss"}>SSS</Select.Option>
              <Select.Option value={"philhealth"}>Phil Health</Select.Option>
              <Select.Option value={"pag-ibig"}>Pag-ibig</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="percentage"
            label="Percentage"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={1}
              max={100}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="1"
              // onChange={(value) => setInputtedPayment(value)}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddGovtContribution;
